
import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as customerReviewsReducerInitialState, HANDLERS as customerReviewsReducerHandler } from "../../../components/desktop/customer-review-card/reducers";

export default {
    [reducerConstants.CUSTOMER_REVIEWS]: { state: customerReviewsReducerInitialState, handler: customerReviewsReducerHandler }
};

